import React, { Component } from 'react'
import { CSSTransition, TransitionGroup } from "react-transition-group";

import '../../App.css';
import '../styles/ContactUsMobile.css'
import '../styles/ContactUsAnim.css'

import ContactUsCircle from '../../assets/Contact Us Circle.svg';
import kindredlogo from '../../assets/kp png logo.svg';
import X from '../../assets/X.svg';

const timeout = 500;

export default class ContactUs extends Component {

	render() {

		if (this.props.hidden) {
			return (
				<div />
			);
		}

		let content = null;

		if (this.props.visible) {
			content = <div className="mobile-contact-us-container">

				<div className="contact-us-btn-container">
					<div className="contact-us-btn" onClick={this.props.clickAction}>
						<img src={ContactUsCircle} className="contact-us-circle" />
						<img src={X} className="contact-us-x" />
					</div>
				</div>

				<div className="mobile-contact-us-flex-container">
					<div className="contact-us-inner-container">

						<div className="form-container">
							<div className="title">Say Hello.</div>

							<div className="form">

								<div className="mobile-dropdown-container">
									<div className="custom-select">
										<select id="topic" value={this.props.topic} onChange={this.props.setTopic}>
											<option>I'd like to talk about</option>
											<option value="working">Working together</option>
											<option value="joining">Joining your team</option>
											<option value="etc">Something else</option>
										</select>
									</div>
								</div>

								<div className="name-email-container">
									<div className="input-name">
										<input className="input-sml" value={this.props.name} placeholder="Name" onChange={this.props.setName} />
									</div>
									<div className="input-email">
										<input className="input-sml" value={this.props.email} placeholder="Email Address" onChange={this.props.setEmail} />
									</div>
								</div>

								<div className="message-container">
									<div className="input-message">
										<textarea className="input-msg" value={this.props.message} placeholder="Message" rows='4' onChange={this.props.setMessage}/>
									</div>
								</div>

								<div className="send-btn-container">
									<div className="message-status-text">
										{this.props.status}
									</div>
									<div className="send-btn" onClick={this.props.sendMessage}>Send ></div>
								</div>

							</div>
						</div>

						<div className="address-container">
							<img src={kindredlogo} className="logo" />
							<div className="text">
								<span className="name">{this.props.companyName}</span>
								<span className="contact-details-line1">{this.props.address}</span>
								<span className="contact-details-line2">{this.props.contactNo}</span>
							</div>
						</div>

					</div>
				</div>
			</div>;
		} else {
			content = <div className="contact-us-btn-container">
				<div className="contact-us-btn" onClick={this.props.clickAction}>
					<img src={ContactUsCircle} className="contact-us-circle" />
					<span className="contact-us-btn-text">Contact Us</span>
				</div>
			</div>;
		}

		return (
			<TransitionGroup>
				<CSSTransition
					key={this.props.visible}
					in={true}
					appear={true}
					timeout={timeout}
					classNames='contact-us-anim'>
					{content}
				</CSSTransition>
			</TransitionGroup>
		);

	}
}
